module.exports = __webpack_public_path__ + "static/img/bgc2.552cb1d6.png";